import { api } from '@api';
import { useGetProfileWithKyc } from '@hooks/TRPC_Hooks/useGetIsKycAvailable';
import { useTranslation } from '@hooks/useTranslation';
import { ExpectedProps } from '@lib/factory/serverprops';
import SumsubWebSdk from '@sumsub/websdk-react';
import cn from 'classnames';
import { NextPage } from 'next';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import s from './kycPage.module.scss';
import { PageLayout } from '@components/PageLayout/PageLayout';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { LinksEnum } from '@specs/navigation';
import { useShowToast } from '@hooks/useShowToast';
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = () => {
  const {
    showToast
  } = useShowToast();
  const {
    translate: tr
  } = useTranslation();
  const {
    status
  } = useSession();
  const router = useRouter();
  const [accessToken, setAccessToken] = useState<string>('');
  const {
    data: profile,
    isLoading: isProfileLoading
  } = useGetProfileWithKyc();
  const [fetchStatus, setFetchStatus] = useState<'fetching' | 'error' | 'completed' | null>(null);
  const {
    mutateAsync: refetchAccessToken
  } = api.SumsubManager.createAccessKey.useMutation({
    mutationKey: ['SumsubManager.createAccessKey'],
    onSuccess: data => {
      if (data.status === 'success') {
        setAccessToken(data.result.accessToken);
        setFetchStatus('completed');
      } else {
        showToast({
          variant: 'error',
          text: data.code
        });
        setFetchStatus('error');
      }
    },
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
      setFetchStatus('error');
    }
  });
  useEffect(() => {
    status === 'unauthenticated' && router.push(LinksEnum.SIGN_IN);
  }, [status]);
  useEffect(() => {
    profile?.kyc?.result === 'GREEN' && router.push(LinksEnum.PAYMENT_WITHDRAW);
  }, [profile]);
  const expirationHandler = async () => {
    if (!profile) return '';
    setFetchStatus('fetching');
    const data = await refetchAccessToken();
    return data.status === 'success' ? data.result.accessToken : '';
  };
  useEffect(() => {
    if (!profile) return;
    expirationHandler();
  }, [profile]);
  const isLoading = status === 'authenticated' && isProfileLoading || fetchStatus === 'fetching';
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.kycPage}>
                <div className={cn(s.kycPage__container, '_container')}>
                    <h1 className={cn(s.kycPage__title, '_title')}>
                        {tr({
            id: 'kyc.apply'
          })}
                    </h1>
                    <div className={s.kycPage__form}>
                        {isLoading ? <LogoLoader /> : <>
                                {fetchStatus === 'completed' && <SumsubWebSdk accessToken={accessToken} expirationHandler={expirationHandler} />}
                                {fetchStatus === 'error' && tr({
              id: 'error.default'
            })}
                            </>}
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default Page;